import {
  MdDashboard,
  MdReport,
  MdCategory,
  MdOutlineCategory,
  MdOutlineEventAvailable,
  MdPayments,
} from "react-icons/md";
import {
  FaClipboardList,
  FaCalendarAlt,
  FaBoxOpen,
  FaUserTie,
  FaUserAlt,
  FaUsersCog,
  FaUsers,
  FaBlog,
  FaBullhorn,
  FaTasks,
  FaQuoteRight,
} from "react-icons/fa";
import { BiGitBranch } from "react-icons/bi";
import { RiCouponLine, RiServiceLine } from "react-icons/ri";
import { Package } from "lucide-react";
import { AiOutlineProduct } from "react-icons/ai";
import { TbReportSearch } from "react-icons/tb";

export const SUPER_ADMIN_MENU = [
  // 1. Overview
  {
    label: "Dashboard",
    key: "dashboard",
    path: "/dashboard",
    icon: MdDashboard,
  },

  // 2. Operations (Day-to-Day)
  {
    label: "Bookings",
    key: "bookings",
    path: "/bookings",
    icon: FaClipboardList,
  },

  {
    label: "Slot Config",
    dropdownKey: "slot-management",
    isDropdown: true,
    icon: MdOutlineEventAvailable,
    children: [
      {
        label: "Slot Templates",
        key: "slots",
        path: "/slots",
        icon: MdOutlineEventAvailable,
      },
      {
        label: "Slot Availability",
        key: "slots-availability",
        path: "/slots-availability",
        icon: FaCalendarAlt,
      },
    ],
  },

  // 3. Catalog Management (What you sell)
  {
    label: "Service Catalog",
    dropdownKey: "service-management",
    isDropdown: true,
    icon: RiServiceLine,
    children: [
      {
        label: "Categories",
        key: "categories",
        path: "/categories",
        icon: MdCategory,
      },
      {
        label: "Sub Categories",
        key: "sub-categories",
        path: "/sub-categories",
        icon: MdOutlineCategory,
      },
      {
        label: "Services",
        key: "services",
        path: "/admin/services",
        icon: RiServiceLine,
      },
      {
        label: "Packages",
        key: "packages",
        path: "/admin/packages",
        icon: FaBoxOpen,
      },
    ],
  },

  {
    label: "Products Catalog",
    dropdownKey: "products-management",
    isDropdown: true,
    icon: FaBoxOpen,
    basePath: "/products-management",
    children: [
      {
        label: "All Products",
        key: "all-products",
        path: "/products-management/all-products",
        icon: Package,
      },
      {
        label: "Product Requests",
        key: "product-requests",
        path: "/products-management/product-requests",
        icon: FaClipboardList,
      },
      {
        label: "Product Ledger",
        key: "product-ledger",
        path: "/products-management/ledger",
        icon: FaClipboardList,
      },
    ],
  },

  // 4. Organization & People (Who runs the system)
  {
    label: "Organization",
    dropdownKey: "organization",
    isDropdown: true,
    icon: FaUserTie,
    children: [
      {
        label: "Branches",
        key: "branch",
        path: "/branch",
        icon: BiGitBranch,
      },
      {
        label: "Managers",
        key: "managers",
        path: "/staff-management/manager",
        icon: FaUserAlt,
      },
      {
        label: "Staff",
        key: "staff",
        path: "/staff-management/staff",
        icon: FaUsersCog,
      },
    ],
  },

  // 5. External Actors
  {
    label: "Customers",
    key: "customers",
    path: "/customers",
    icon: FaUsers,
  },
  {
    label: "Vendors",
    key: "vendors",
    path: "/vendors",
    icon: AiOutlineProduct,
  },

  // 6. Content & Growth
  {
    label: "Blogs",
    key: "blogs",
    path: "/admin/blog",
    icon: FaBlog,
  },
  {
    label: "Banners",
    key: "banners",
    path: "/admin/banners",
    icon: FaBullhorn,
  },
  {
    label: "Testimonials",
    key: "testimonials",
    path: "/admin/testimonials",
    icon: FaQuoteRight,
  },
  {
    label: "Coupons",
    key: "coupons",
    path: "/admin/coupons",
    icon: RiCouponLine,
  },


  // 7. Finance & Accounting (Endgame)
  {
    label: "Finance",
    dropdownKey: "finance",
    isDropdown: true,
    icon: MdPayments,
    children: [
      {
        label: "Invoices",
        key: "invoices",
        path: "/invoices",
        icon: MdReport,
      },
      {
        label: "Reports",
        key: "reports",
        path: "/reports",
        icon: TbReportSearch,
      },
      {
        label: "Payment QR",
        key: "payment-qr",
        path: "/admin/payment-qr",
        icon: MdPayments,
      },
    ],
  },
];

export const STAFF_MENU = [
  {
    label: "Dashboard",
    path: "/dashboard-staff",
    permission: "dashboard-staff",
    icon: MdDashboard,
  },
  {
    label: "My Jobs",
    path: "/my-jobs",
    permission: "my-jobs",
    icon: FaTasks,
  },
  // {
  //   label: "Products",
  //   path: "/products",
  //   permission: "products",
  //   icon: FaBoxOpen,
  //   dropdownKey: "products",
  //   isDropdown: true,
  //   children: [
  {
    label: "All Products",
    path: "/all-products",
    permission: "all-products",
    icon: Package,
  },
  {
    label: "Request stats",
    path: "/request-stats",
    permission: "request-stats",
    icon: FaClipboardList,
  },
  //   ],
  // },
];

export const applyPermissions = (menu, permissions = []) =>
  menu
    .map((item) => {
      if (item.children) {
        const children = item.children.filter((c) =>
          permissions.includes(c.key),
        );

        if (children.length === 0) return null;

        return { ...item, children };
      }

      return permissions.includes(item.key) ? item : null;
    })
    .filter(Boolean);

// export const PERMISSION_GROUPS = {
//   Dashboard: ["dashboard"],

//   "Bookings & Reports": ["bookings", "reports", "invoices"],

//   "Slot Management": ["slots", "slots-availability"],

//   "Service Management": ["categories", "sub-categories", "services"],

//   Products: ["all-products", "product-requests", "product-ledger"],

//   Organization: ["branch", "managers", "staff"],

//   Customers: ["customers"],
//   Vendors: ["vendors"],

//   Content: ["blogs", "banners"],

//   Payments: ["payment-qr"],
// };

export const PERMISSION_GROUPS = {
  Dashboard: ["dashboard"],

  Operations: ["bookings"],

  "Slot Management": ["slots", "slots-availability"],

  "Service Catalog": ["categories", "sub-categories", "services", "packages"],

  "Products Catalog": ["all-products", "product-requests", "product-ledger"],

  Organization: ["branch", "managers", "staff"],

  Customers: ["customers"],
  Vendors: ["vendors"],

  "Content & Marketing": ["blogs", "banners"],

  "Finance & Accounting": ["reports", "invoices", "payment-qr"],
};

export const extractPermissionsFromMenu = (menu = []) => {
  const permissions = new Set();

  const walk = (items) => {
    items.forEach((item) => {
      if (item.key) {
        permissions.add(item.key);
      }

      if (Array.isArray(item.children)) {
        walk(item.children);
      }
    });
  };

  walk(menu);
  return Array.from(permissions);
};
